import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import { RenderedFunctionComponent } from 'components/initAdminComponents'
import { RootContainer } from 'components/RootContainer/RootContainer'
import { AdvantagesSection } from 'components/Smp/LandingPage/AdvantagesSection/AdvantagesSection'
import { HeroSection } from 'components/Smp/LandingPage/HeroSection/HeroSection'
import { ThemeSection } from 'components/Smp/LandingPage/ThemeSection/ThemeSection'
import { ThreeStepsSection } from 'components/Smp/LandingPage/ThreeStepsSection/ThreeStepsSection'
import React from 'react'

export const SmpLandingPage: RenderedFunctionComponent = () => (
  <RootContainer>
    <Box component='section'>
      <HeroSection />
    </Box>
    <Box component='section' mt={ 10 }>
      <ThemeSection />
    </Box>
    <Box component='section' maxWidth='97rem' mx='auto'>
      <Divider />
    </Box>
    <Box component='section' mb={ 5 }>
      <AdvantagesSection />
    </Box>
    <Box component='section' maxWidth='97rem' mx='auto'>
      <Divider />
    </Box>
    <Box component='section' mt={ 5 }>
      <ThreeStepsSection />
    </Box>
  </RootContainer>
)

SmpLandingPage.queryString = 'div.smp-landing-page'
